"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserScheduledToBeOnBreak = void 0;
const is_date_in_schedule_item_1 = require("./is-date-in-schedule-item");
function isUserScheduledToBeOnBreak(shifts, date) {
    return shifts.some(shift => shift.scheduled_breaks.some(scheduledBreak => (0, is_date_in_schedule_item_1.isDateInScheduleItem)(scheduledBreak, date)));
}
exports.isUserScheduledToBeOnBreak = isUserScheduledToBeOnBreak;
